import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import MultiRangeSlider from "../../../Components/MultiRangeSlider";
import DatePicker from "react-datepicker";
import moment from "moment";
import Input from "../../../Components/Input";
import Select from "../../../Components/Select";
import DateInput from "../../../Components/DateInput";
import SingleSearchSelect from "../../../Components/SingleSearchSelect";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useHistory } from "react-router-dom";
import ModelContainer from "../../../Components/ModelContainer";

const ReceivableDetail = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const receivableDetails = useSelector(
    (state) => state?.orderInvoicesReducer?.receivableDetails
  );
  console.log(receivableDetails, "receivableDetails");
  const firstDateOfMonth =
    new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + 1;

  const initialData = {
    from_date: moment(firstDateOfMonth).format("yyyy-MM-DD"),
    to_date: moment(new Date()).format("yyyy-MM-DD"),
    // start_time: "12.00 am",
    // end_time: "12.00 pm",
    id: params?.location?.state?.id,
  };
  const [startDate, setStartDate] = useState(moment(firstDateOfMonth).toDate());
  const [endDate, setEndDate] = useState(new Date());
  const [data, setData] = useState(initialData);

  useEffect(() => {
    dispatch(actions?.getReceivableDetails(initialData));
  }, []);

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div class="row mx-0">
                  {/* <div className="field text-right mt-3 pt-1 px-0">
                    <button
                      onClick={() => history.push("/finance/sales")}
                      class="btn green-btn-revert mx-0"
                      id="addCount"
                      type="button"
                    >
                      Back to Sales
                    </button>
                  </div> */}
                  <div class="shadowclass top_filters orderpayy mb-3">
                    <h4 class="event-alert py-0 my-2">Filters </h4>
                    <div className="row mx-0">
                      <div class="col-lg-4 col-md-6 pl0 px-0 px-sm-3">
                        <div class="calander d-flex align-items-center">
                          <div class="datePicker pading_right">
                            {/* // <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                            //   <input
                            //     name="from_date"
                            //     class=" "
                            //     required="required"
                            //     type="text"
                            //     id=""
                            //     value="2022-05-01"
                            //   />
                            //   <span class="add-on">
                            //     <i class="fa fa-calendar"></i>
                            //   </span>
                            // </div> */}
                            <DatePicker
                              selected={startDate}
                              dateFormat="dd/MM/yyyy"
                              onChange={(date) => {
                                setStartDate(date);
                                setData({
                                  ...data,
                                  from_date: moment(date).format("yyyy-MM-DD"),
                                });
                              }}
                            />
                          </div>
                          <div class="datePicker pading_lect">
                            {/* <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                              <input
                                name="to_date"
                                class=" "
                                required="required"
                                type="text"
                                id=""
                                value="2022-05-13"
                              />
                              <span class="add-on">
                                <i class="fa fa-calendar"></i>
                              </span>
                            </div> */}
                            <DatePicker
                              selected={endDate}
                              dateFormat="dd/MM/yyyy"
                              onChange={(date) => {
                                setEndDate(date);
                                setData({
                                  ...data,
                                  to_date: moment(date).format("yyyy-MM-DD"),
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-2 col-md-6 timing-duration pt-4 pt-sm-0 mt-md-3 mt-0 mt-lg-0 px-sm-2">
                        <MultiRangeSlider
                          min={0}
                          max={1440}
                          timeRange
                          format="12"
                          onChange={({ min, max }) => {
                            console.log(`min = ${min}, max = ${max}`);
                            setData({
                              ...data,
                              start_time: min,
                              end_time: max,
                            });
                          }}
                        />
                      </div>
                      <div class="selecters col-lg-5 col-md-10 pl-md-0 row mx-0 justify-content-between pt-0 pt-lg-0">
                        <div class="select-div col px-1 pl-md-0">
                          <div class="input select">
                            <select
                              name="waste_group"
                              class="csutom_select"
                              id="WasteWasteGroup"
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  status_id: e.target.value,
                                })
                              }
                            >
                              <option value="">Paid By</option>
                              {receivableDetails?.paid_by_payment?.map((el) => (
                                <option value={el?.value}>{el?.label}</option>
                              ))}
                            </select>
                          </div>{" "}
                        </div>
                        {/* <div class="select-div col px-1">
                          <div class="input select">
                            <select
                              name="waste_type"
                              class="csutom_select"
                              id="WasteWasteType"
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  type: e.target.value,
                                })
                              }
                            >
                              <option value="">Type</option>
                              {receivableDetails?.type?.map((el) => (
                                <option value={el?.value}>{el?.label}</option>
                              ))}
                            </select>
                          </div>{" "}
                        </div> */}
                        <div class="select-div col px-1">
                          <div class="input select">
                            <select
                              name="supplier"
                              class="csutom_select"
                              id="WasteSupplier"
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  customer_id: e.target.value,
                                })
                              }
                            >
                              <option value="">Status</option>
                              <option value="82">Paid</option>
                              <option value="83">Unpaid</option>
                            </select>
                          </div>{" "}
                        </div>
                      </div>
                      <div class="col-lg-1 col px-0 pt-3 pt-lg-0 align-right">
                        <button
                          onClick={() => {
                            dispatch(actions?.getReceivableDetails(data));
                          }}
                          class="btn btn_btnblue"
                          type="submit"
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <InvoiceTable
              tableArr={receivableDetails?.ar_invoices}
              title={"AR Invoices"}
              customerID={params.location.state.id}
            />
            <VouchersTable
              tableArr={receivableDetails?.ar_vouchers}
              title={"AR Vouchers"}
              customerID={params.location.state.id}
            />
          </div>
        </div>
      </div>
    </UserInterface>
  );
};

const InvoiceTable = ({ tableArr, customerID }) => {
  const history = useHistory();
  const [modalState, setModalState] = useState(false);
  const [checks, setChecks] = useState({
    isAllSelected: false,
    selectedArr: [],
  });

  const paySelected = () => {};

  return (
    <div class="shadowclass padding_b ">
      <h4 class="event-alert"> AR Invoices </h4>
      <div class="row-fluid">
        <div class="span4">
          <div class="search-box"></div>{" "}
        </div>
        <div class="span8 float-right">
          <div class="field text-right">
            <button
              id="pay_selected_invoice"
              class="btn green-btn-revert"
              onClick={() => {
                setModalState(true);
                paySelected();
              }}
            >
              Pay Selected
            </button>
          </div>
        </div>
      </div>

      <div class="row-fluid">
        <div class="span12">
          <div class="inner-space screen-scroll chart_acc_td mCustomScrollbar _mCS_3">
            <div class="mCustomScrollBox mCS-light mCSB_horizontal" id="mCSB_3">
              <div class="mCSB_container">
                <table
                  width="100%"
                  cellspacing="0"
                  cellpadding="0"
                  class="checklist-table table850 remove-space inventory_table"
                >
                  <thead>
                    <tr>
                      <th>
                        <a class="checkbox avaiCheck">
                          <input
                            onClick={() => {
                              setChecks({
                                isAllSelected: !checks?.isAllSelected,
                                selectedArr: checks?.isAllSelected
                                  ? []
                                  : tableArr?.map((el) => {
                                      if (
                                        el?.status_id == "83" ||
                                        el?.status_id == "84"
                                      )
                                        return el?.id;
                                    }),
                              });
                            }}
                            checked={checks.isAllSelected}
                            type="checkbox"
                            name="master_check"
                            class="avail_checkbox"
                            value=""
                            id={"checkbox_order_id" + "AR Invoices"}
                          />
                          <label
                            for={"checkbox_order_id" + "AR Invoices"}
                          ></label>
                        </a>
                      </th>
                      <th> ID </th>
                      <th> Status </th>
                      <th> Total Value </th>
                      <th> Invoice Date </th>
                      <th> Payment Details </th>
                      <th> Actions </th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableArr?.map((el, idx) => (
                      <tr class="order_row">
                        <td>
                          {(el?.status_id == "83" || el?.status_id == "84") && (
                            <a class="checkbox avaiCheck">
                              <input
                                onClick={() => {
                                  const targetIdx =
                                    checks?.selectedArr?.findIndex(
                                      (id) => id == el?.id
                                    );
                                  const maxArrLen = tableArr?.length;
                                  const currArrLen =
                                    checks?.selectedArr?.length;

                                  console.log(
                                    targetIdx,
                                    "targetIdx",
                                    [...checks?.selectedArr],
                                    el?.id,
                                    el
                                  );

                                  // id not present in state
                                  if (targetIdx == -1) {
                                    setChecks({
                                      isAllSelected:
                                        maxArrLen - 1 === currArrLen,
                                      selectedArr: [
                                        ...checks?.selectedArr,
                                        el?.id,
                                      ],
                                    });
                                  } else {
                                    // id is present
                                    const copyArr = [...checks?.selectedArr];
                                    copyArr.splice(targetIdx, 1);
                                    setChecks({
                                      isAllSelected: false,
                                      selectedArr: copyArr,
                                    });
                                  }
                                }}
                                type="checkbox"
                                checked={checks?.selectedArr?.includes(el?.id)}
                                class="avail_checkbox invoice_box"
                                id={"order_id_17" + idx + "AR Invoices"}
                              />
                              <label
                                for={"order_id_17" + idx + "AR Invoices"}
                              ></label>
                            </a>
                          )}
                        </td>
                        <td> {el?.ar_invoiceid} </td>
                        <td>
                          <span>{el?.status?.status} </span>{" "}
                        </td>
                        <td>
                          {el?.status_id == "82"
                            ? el?.paid_amount
                            : el?.total_price - el?.paid_amount}
                        </td>
                        <td> {el?.invoice_date}</td>
                        <td>
                          {el?.paid_by === "bank" ? (
                            <>
                              Bank - <span class="green_text">ARS2423434</span>
                              <br /> {el?.paid_date}
                            </>
                          ) : (
                            <>
                              Credit Note -
                              <span class="green_text">
                                {el?.ap_credit_note?.pcn_number}
                              </span>
                              <br /> {el?.paid_date}
                            </>
                          )}
                        </td>
                        <td>
                          <a
                            onClick={() => {
                              history.push(
                                "/order/ar-invoices/new-ar-invoices",
                                {
                                  id: el?.id,
                                  pageType: "edit",
                                }
                              );
                            }}
                            class="circle_icon"
                          >
                            <i class="iconSprites eye-icon">
                              <div class="tooltip-sm"> View </div>{" "}
                            </i>
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div class="mCSB_scrollTools">
                <div class="mCSB_draggerContainer">
                  <div class="mCSB_dragger" oncontextmenu="return false;">
                    <div class="mCSB_dragger_bar"></div>
                  </div>
                  <div class="mCSB_draggerRail"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PaymentModal
        modalState={modalState}
        setModalState={setModalState}
        selectedChecks={checks?.selectedArr}
        type={"AR Invoices"}
        customerID={customerID}
      />
    </div>
  );
};
const VouchersTable = ({ tableArr, customerID }) => {
  const history = useHistory();
  const [modalState, setModalState] = useState(false);
  const [checks, setChecks] = useState({
    isAllSelected: false,
    selectedArr: [],
  });

  const paySelected = () => {};

  return (
    <div class="shadowclass padding_b ">
      <h4 class="event-alert"> AR Vouchers </h4>
      <div class="row-fluid">
        <div class="span4">
          <div class="search-box"></div>{" "}
        </div>
        <div class="span8 float-right">
          <div class="field text-right">
            <button
              id="pay_selected_invoice"
              class="btn green-btn-revert"
              onClick={() => {
                setModalState(true);
                paySelected();
              }}
            >
              Pay Selected
            </button>
          </div>
        </div>
      </div>

      <div class="row-fluid">
        <div class="span12">
          <div class="inner-space screen-scroll chart_acc_td mCustomScrollbar _mCS_3">
            <div class="mCustomScrollBox mCS-light mCSB_horizontal" id="mCSB_3">
              <div class="mCSB_container">
                <table
                  width="100%"
                  cellspacing="0"
                  cellpadding="0"
                  class="checklist-table table850 remove-space inventory_table"
                >
                  <thead>
                    <tr>
                      <th>
                        <a class="checkbox avaiCheck">
                          <input
                            onClick={() => {
                              setChecks({
                                isAllSelected: !checks?.isAllSelected,
                                selectedArr: checks?.isAllSelected
                                  ? []
                                  : tableArr?.map((el) => {
                                      if (el?.status_id == "87") return el?.id;
                                    }),
                              });
                            }}
                            checked={checks.isAllSelected}
                            type="checkbox"
                            name="master_check"
                            class="avail_checkbox"
                            value=""
                            id={"checkbox_order_id" + "AR Vouchers"}
                          />
                          <label
                            for={"checkbox_order_id" + "AR Vouchers"}
                          ></label>
                        </a>
                      </th>
                      <th>ID & Group </th>
                      <th>Status </th>
                      <th>Total Value </th>
                      <th>Redemption Date </th>
                      <th>Payment Details </th>
                      <th>Linked Invoice </th>
                    </tr>
                  </thead>
                  <tbody>
                    {console.log(tableArr, "tableArr")}
                    {tableArr?.map((el, idx) => (
                      <tr class="order_row">
                        <td>
                          {el?.status_id == "87" && (
                            <a class="checkbox avaiCheck">
                              <input
                                onClick={() => {
                                  const targetIdx =
                                    checks?.selectedArr?.findIndex(
                                      (id) => id == el?.id
                                    );
                                  const maxArrLen = tableArr?.length;
                                  const currArrLen =
                                    checks?.selectedArr?.length;

                                  console.log(
                                    targetIdx,
                                    "targetIdx",
                                    [...checks?.selectedArr],
                                    el?.id,
                                    el
                                  );

                                  // id not present in state
                                  if (targetIdx == -1) {
                                    setChecks({
                                      isAllSelected:
                                        maxArrLen - 1 === currArrLen,
                                      selectedArr: [
                                        ...checks?.selectedArr,
                                        el?.id,
                                      ],
                                    });
                                  } else {
                                    // id is present
                                    const copyArr = [...checks?.selectedArr];
                                    copyArr.splice(targetIdx, 1);
                                    setChecks({
                                      isAllSelected: false,
                                      selectedArr: copyArr,
                                    });
                                  }
                                }}
                                type="checkbox"
                                checked={checks?.selectedArr?.includes(el?.id)}
                                class="avail_checkbox invoice_box"
                                id={"order_id_17" + idx + "AR Vouchers"}
                              />
                              <label
                                for={"order_id_17" + idx + "AR Vouchers"}
                              ></label>
                            </a>
                          )}
                        </td>
                        <td>
                          <b>{el?.voucher_id}</b> <br />{" "}
                          {el?.payment_method?.method_name}{" "}
                        </td>
                        <td>
                          <span>{el?.status?.status} </span>{" "}
                        </td>
                        <td>
                          {el?.status_id == "86"
                            ? el?.paid_amount
                            : el?.redeem_amount}
                        </td>
                        <td> {el?.redemption_date}</td>
                        <td>
                          {el?.paid_by === "bank" ? (
                            el?.payment_receipt_debit_account_id ? (
                              <>
                                Bank -{" "}
                                <span class="green_text">". ARS2423434."</span>
                                <br /> {el?.paid_date}
                              </>
                            ) : (
                              <>
                                Bank -{" "}
                                <span class="green_text">". ARS2423434."</span>
                                <br /> {el?.linked_invoice}
                              </>
                            )
                          ) : el?.linked_invoice?.ap_credit_note?.pcn_number ? (
                            <>
                              Credit Note -
                              <span class="green_text">
                                {el?.ap_credit_note?.pcn_number}
                              </span>
                              <br /> {el?.linked_invoice?.paid_date}
                            </>
                          ) : (
                            <>
                              Credit Note -
                              <span class="green_text">
                                {el?.ap_credit_note?.pcn_number}
                              </span>
                              <br /> {el?.paid_date}
                            </>
                          )}
                        </td>
                        <td>
                          <a
                            onClick={() => {
                              history.push(
                                "/order/ar-invoices/new-ar-invoices",
                                {
                                  id: el?.id,
                                  pageType: "edit",
                                }
                              );
                            }}
                            class="circle_icon"
                          >
                            <i class="iconSprites eye-icon">
                              <div class="tooltip-sm"> View </div>{" "}
                            </i>
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div class="mCSB_scrollTools">
                <div class="mCSB_draggerContainer">
                  <div class="mCSB_dragger" oncontextmenu="return false;">
                    <div class="mCSB_dragger_bar"></div>
                  </div>
                  <div class="mCSB_draggerRail"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PaymentModal
        modalState={modalState}
        setModalState={setModalState}
        selectedChecks={checks?.selectedArr}
        type={"AR Vouchers"}
        customerID={customerID}
      />
    </div>
  );
};

const PaymentModal = ({
  modalState,
  setModalState,
  selectedChecks,
  type,
  customerID,
}) => {
  const dispatch = useDispatch();
  const receivableDetails = useSelector(
    (state) => state?.orderInvoicesReducer?.receivableDetails
  );
  const [selectedPayableAccount, setSelectedPayableAccount] = useState([]);
  const [selectedReceiptAccount, setSelectedReceiptAccount] = useState([]);
  const [creditNoteDate, setCreditNoteDate] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    setValue("customer_id", customerID?.toString());
    setValue("pay_by", receivableDetails?.paid_by_payment?.[0]?.value);
  }, [receivableDetails]);

  const addEditDefaultValue = {
    ar_invoice_ids: [],
    ar_voucher_ids: [],
    customer_id: "",
    pay_by: "",
    payment_receipt_debit_account_id: "",
    bank_charges: "",
    final_payment_received: "",
    ap_debit_account_id: "",
    credit_noteid: "",
    credit_note_date: "",
    commission_deducted: "",
    credit_note_value: "",
    actual_payment: "",
  };
  const schema = yup.object().shape({
    ar_invoice_ids: yup.array().required(),
    ar_voucher_ids: yup.array().required(),
    customer_id: yup.string().required(),
    pay_by: yup.string().required(),

    payment_receipt_debit_account_id: yup.string().when("pay_by", {
      is: "bank",
      then: yup.string().required(),
    }),

    bank_charges: yup.string().when("pay_by", {
      is: "bank",
      then: yup.string().required(),
    }),
    final_payment_received: yup.string().when("pay_by", {
      is: "bank",
      then: yup.string().required(),
    }),

    ap_debit_account_id: yup.string().when("pay_by", {
      is: "credit_note",
      then: yup.string().required(),
    }),
    credit_noteid: yup.string().when("pay_by", {
      is: "credit_note",
      then: yup.string().required(),
    }),
    credit_note_date: yup.string().when("pay_by", {
      is: "credit_note",
      then: yup.string().required(),
    }),
    commission_deducted: yup.string().required(),
    credit_note_value: yup.string().when("pay_by", {
      is: "credit_note",
      then: yup.string().required(),
    }),

    actual_payment: yup.string().required(),
  });
  const {
    register: register,
    formState: { errors },
    handleSubmit,
    reset,
    getValues,
    setValue,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    // mode: "all",
    // reValidateMode: "onChange",
    defaultValues: addEditDefaultValue,
  });
  const watchAllInputs = watch();
  console.log(watchAllInputs, "ppppppppppp");

  function submitData(data) {
    console.log(data);
    dispatch(actions?.postReceivePayments({ data, setModalState }));
  }

  function calcTotalAmount() {
    let arInvoicesTotal;
    let arVouchersTotal;

    if (type === "AR Invoices") {
      arInvoicesTotal = receivableDetails?.ar_invoices?.reduce((acc, el) => {
        if (selectedChecks.includes(el?.id)) acc = acc + el?.total_price;
        return acc;
      }, 0);

      setValue("actual_payment", arInvoicesTotal);
      setTotalAmount(arInvoicesTotal);

      if (watchAllInputs?.pay_by === "bank")
        setValue(
          "final_payment_received",
          arInvoicesTotal -
            watchAllInputs?.bank_charges -
            watchAllInputs?.commission_deducted
        );
      else if (watchAllInputs?.pay_by === "credit_note")
        setValue(
          "credit_note_value",
          arInvoicesTotal - watchAllInputs?.commission_deducted
        );
      return;
    } else if (type === "AR Vouchers") {
    }
  }

  useEffect(() => {
    calcTotalAmount();
    console.log("hiiii", customerID, selectedChecks);
    if (type === "AR Invoices") setValue("ar_invoice_ids", selectedChecks);
    if (type === "AR Vouchers") setValue("ar_invoice_ids", selectedChecks);
  }, [
    watchAllInputs?.bank_charges,
    watchAllInputs?.commission_deducted,
    modalState,
  ]);

  return (
    <ModelContainer
      title={`Receive Payment`}
      open={modalState}
      closeModal={() => setModalState(false)}
      submitModal={handleSubmit(submitData)}
    >
      <form>
        {console.log("Errors", errors)}
        <div className="form-list">
          <ul className="px-0">
            <Select
              label={"Pay by :"}
              formRegister={register}
              formError={errors}
              formKey="pay_by"
              optionsArray={receivableDetails?.paid_by_payment}
              onChange={(e) => {
                setValue("pay_by", e.target.value);
              }}
            />
            {watchAllInputs?.pay_by === "bank" && (
              <SingleSearchSelect
                label={"Payment Receipt Debit Account"}
                formRegister={register}
                formError={errors}
                formKey="payment_receipt_debit_account_id"
                selected={selectedPayableAccount}
                setSelected={setSelectedPayableAccount}
                options={receivableDetails?.payment_accounts}
                setValue={setValue}
              />
            )}

            {watchAllInputs?.pay_by === "credit_note" && (
              <SingleSearchSelect
                label={"Account Payable Debit Account"}
                formRegister={register}
                formError={errors}
                formKey="ap_debit_account_id"
                selected={selectedReceiptAccount}
                setSelected={setSelectedReceiptAccount}
                options={receivableDetails?.ap_sub_accounts}
                setValue={setValue}
              />
            )}
            {watchAllInputs?.pay_by === "credit_note" && (
              <Input
                label={"Credit Note ID"}
                formRegister={register}
                formError={errors}
                formKey="credit_noteid"
                onChange={(e) => {
                  setValue("credit_noteid", e.target.value);
                }}
              />
            )}
            {watchAllInputs?.pay_by === "credit_note" && (
              <DateInput
                label={"Credit Note Date"}
                formRegister={register}
                formError={errors}
                formKey="credit_note_date"
                setFormField={setValue}
                dateVal={creditNoteDate}
                horizontal={false}
                setDateVal={setCreditNoteDate}
              />
            )}
            <Input
              label={"Commission Deducted"}
              formRegister={register}
              formError={errors}
              formKey="commission_deducted"
              onChange={(e) => {
                setValue("commission_deducted", e.target.value);
              }}
            />
            {watchAllInputs?.pay_by === "bank" && (
              <Input
                label={"Bank Charges"}
                formRegister={register}
                formError={errors}
                formKey="bank_charges"
                onChange={(e) => {
                  setValue("bank_charges", e.target.value);
                }}
              />
            )}

            {watchAllInputs?.pay_by === "bank" && (
              <li style={{ display: "flex", justifyContent: "space-between" }}>
                <label>Final Payment Received</label>
                <b style={{ fontSize: "20px" }}>
                  {receivableDetails?.currency}
                  {totalAmount -
                    watchAllInputs?.bank_charges -
                    watchAllInputs?.commission_deducted}
                </b>
              </li>
            )}

            {watchAllInputs?.pay_by === "credit_note" && (
              <li style={{ display: "flex", justifyContent: "space-between" }}>
                <label>Credit Note Value</label>
                <b style={{ fontSize: "20px" }}>
                  {receivableDetails?.currency}
                  {totalAmount - watchAllInputs?.commission_deducted}
                </b>
              </li>
            )}
          </ul>
        </div>
      </form>
    </ModelContainer>
  );
};
export default ReceivableDetail;
